import React, { Component } from 'react'

import './loader.scss'

export default class Loader extends Component {
	state = {
		show: false,
	}

	timer = null

	componentDidMount() {
		this.timer = setTimeout(() => {
			this.setState({ show: true })
		}, 1000)
	}

	componentWillUnmount() {
		clearTimeout(this.timer)
	}

	render() {
		const { show } = this.state
		return show ? (
			<div className="c-loader">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="19"
					height="35"
					viewBox="0 0 19 35"
				>
					<defs>
						<linearGradient
							id="skara-signet-a"
							x1="0%"
							y1="0%"
							y2="100%"
						>
							<stop offset="0%" stopColor="#A68EFF" />
							<stop offset="100%" stopColor="#EC96F8" />
						</linearGradient>
					</defs>
					<path
						fill="url(#skara-signet-a)"
						fillRule="evenodd"
						d="M12.232 24.657L5.48 28.562l-2.643-1.535 6.752-3.905 2.643 1.535zm-7.261-8.89l7.996 4.57-.027 3.07-2.963-1.73a.398.398 0 0 0-.089-.043l.002.004-7.956-4.57.032-7.807 2.668 1.54-.025 4.338a.712.712 0 0 0 .362.628zm4.368-8.509l-.007-.011-3.98 2.313L2.69 8.023l10.376-5.978L15.71 3.58 9.34 7.258zm-.273 4.848L6.05 13.895l.017-3.093L9.53 8.789l.005.01 6.892-3.98.008 3.057-7.368 4.23zM6.76 15.139l2.64-1.533 6.95 3.961-2.64 1.545-6.95-3.973zm10.3 3.672l-.032 7.79-3.429 1.993-.005-.009-7.39 4.274-.008-3.056 7.823-4.523a.68.68 0 0 0 .344-.666l.036-4.247 2.662-1.556zM4.773 32.851l-2.634-1.53-.008-3.049 2.635 1.531.007 3.048zm13.366-15.914l-7.331-4.179 6.7-3.847a.718.718 0 0 0 .36-.624l-.013-4.707a.704.704 0 0 0-.363-.62L13.43.598a.712.712 0 0 0-.72-.003L.933 7.383a.716.716 0 0 0-.393.636L.5 17.48a.717.717 0 0 0 .358.622l7.297 4.195-7.087 4.1-.084.054a.726.726 0 0 0-.29.577l.013 4.709a.719.719 0 0 0 .356.616l4.071 2.365a.703.703 0 0 0 .634.037l7.981-4.603.005.01 4.349-2.528a.72.72 0 0 0 .356-.616l.04-9.427a.713.713 0 0 0-.361-.653z"
					/>
				</svg>
			</div>
		) : null
	}
}
